/**
 * @typedef {Object} Stat
 * @property {string} num - numeric portion (e.g., "150")
 * @property {string} accent - accent suffix rendered in accent color (e.g., "M+")
 * @property {"azure" | "coral" | "cobalt"} accentColor - accent token
 * @property {string} label - descriptive label below the number
 */

/** @type {Stat[]} */
export const stats = [
  { num: "150", accent: "M+", accentColor: "azure", label: "Emails acquired" },
  { num: "5,000", accent: "+", accentColor: "coral", label: "Partner brands" },
  { num: "25K", accent: "+", accentColor: "cobalt", label: "Campaigns run" },
];
